import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'
import Meta from 'vue-meta'
import VueI18n from 'vue-i18n'
import en from './lang/en.json'
import pl from './lang/pl.json'
import { defaultLocale } from './lang.js'
import { locale } from './lang.js'
import store from './store'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

require('./styles/main.sass')

if(process.env.VUE_APP_GA){
    Vue.use(VueAnalytics, {
        id: process.env.VUE_APP_GA,
        debug: {
            sendHitTask: process.env.NODE_ENV === 'production'
        },
        router
    })
}
// console.log(locale);
Vue.use(VueScrollTo,{ offset: -80 })
Vue.use(Meta)
Vue.use(VueI18n)
Vue.use(VueCookies)
const i18n = new VueI18n({
    locale: (locale.trim().length && locale != "/") ? locale : defaultLocale,
    fallbackLocale: defaultLocale,
    messages: { en, pl }
})

const vm = new Vue({
    router,
    i18n,
    store,
    render: h => h(App)
})

store.dispatch('fetchContent')
.then(() => {
    document.dispatchEvent(new Event('render-event'))
    vm.$mount('#app')
})
.catch((error) => {
    console.log(error);
});

String.prototype.urlToSlug = function(){
    let slug = this.replace('/post/','').replace(new RegExp('/', 'g'),'')
    return (slug == '') ? 'home' : slug
}
